/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { HandPointButtonIcon16Light } from './HandPointButtonIcon16Light';
import { HandPointButtonIcon16Regular } from './HandPointButtonIcon16Regular';
import { HandPointButtonIcon16Solid } from './HandPointButtonIcon16Solid';
import { HandPointButtonIcon20Light } from './HandPointButtonIcon20Light';
import { HandPointButtonIcon20Regular } from './HandPointButtonIcon20Regular';
import { HandPointButtonIcon20Solid } from './HandPointButtonIcon20Solid';
import { HandPointButtonIcon24Regular } from './HandPointButtonIcon24Regular';
import { HandPointButtonIcon24Solid } from './HandPointButtonIcon24Solid';
import { HandPointButtonIcon32Regular } from './HandPointButtonIcon32Regular';
import { HandPointButtonIcon64Regular } from './HandPointButtonIcon64Regular';
var sizes = {
    16: {
        light: HandPointButtonIcon16Light,
        regular: HandPointButtonIcon16Regular,
        solid: HandPointButtonIcon16Solid,
    },
    20: {
        light: HandPointButtonIcon20Light,
        regular: HandPointButtonIcon20Regular,
        solid: HandPointButtonIcon20Solid,
    },
    24: {
        regular: HandPointButtonIcon24Regular,
        solid: HandPointButtonIcon24Solid,
    },
    32: {
        regular: HandPointButtonIcon32Regular,
    },
    64: {
        regular: HandPointButtonIcon64Regular,
    },
};
export var HandPointButtonIcon = forwardRef('HandPointButtonIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
